import { render } from "./index.vue?vue&type=template&id=690571b0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=690571b0&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=690571b0&lang=scss"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690571b0"]])

export default __exports__